import { render, staticRenderFns } from "./SsoStatusCard.vue?vue&type=template&id=1b9a0cbe&scoped=true&"
import script from "./SsoStatusCard.vue?vue&type=script&lang=js&"
export * from "./SsoStatusCard.vue?vue&type=script&lang=js&"
import style0 from "./SsoStatusCard.vue?vue&type=style&index=0&id=1b9a0cbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9a0cbe",
  null
  
)

export default component.exports